// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"c7a465a3","415":"431e687b","701":"90fc3c1e","904":"79a542a7"}[chunkId] + ".chunk.css";
};